import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { userDetail } from 'Stores/userDetail';
import { Utils } from 'Utils/utils';
import logo from 'Assets/logo/logo_new.png';
import * as CONSTANTS from 'Utils/constants';

const NavigationWrapper = observer(props => {
  const { isFreeTrial, isEnterpriseFreeTrial } = userDetail;

  const { location } = props;
  const { pathname } = location;
  const currentPath = pathname;

  const defaultSideNavItems = [
    // {
    //   path: '/dashboard',
    //   mainPath: '/dashboard',
    //   navName: 'dashboard',
    //   title: 'Dashboard',
    //   icon: 'home',
    //   // imgComponent: HomePageIcon,
    //   id: 'homeNavBar',
    // },
    {
      path: '/advanced-search/contact#search',
      mainPath: '/advanced-search/contact',
      navName: 'advancedSearch',
      title: 'Contact Search',
      icon: 'search',
      // imgComponent: ContactIcon,
      id: 'advSearchNavBar',
    },
    {
      path: '/advanced-search/company#search',
      mainPath: '/advanced-search/company',
      navName: 'companySearch',
      title: 'Company Search',
      icon: 'search',
      // imgComponent: CompanySearchIcon,
      // isSvg: true,
      id: 'companySearchNavBar',
    },
    {
      path: '/my-leads',
      mainPath: '/my-leads',
      navName: 'myleads',
      title: 'My Lists',
      icon: 'people_outline',
      // imgComponent: LeadsIcon,
      id: 'myLeadsNavBar',
    },
    {
      path: '/seeker',
      mainPath: '/seeker',
      navName: 'seeker',
      title: 'Seeker',
      icon: 'mail',
      // isSvg: true,
      // imgComponent: SeekerIcon,
      id: 'seekerNavBar',
    },
    {
      path: '/enrichment',
      mainPath: '/enrichment',
      navName: 'enrichment',
      title: 'Enrichment',
      id: 'enrichmentNavBar',
    },
    {
      path: '/integrations',
      mainPath: '/integrations',
      navName: 'integrations',
      title: 'Integrations',
      // icon: 'mail',
      // imgComponent: SeekerIcon,
      id: 'integrationsNavBar',
    },
    {
      path: '/concierge',
      mainPath: '/concierge',
      navName: 'concierge',
      title: 'Concierge',
      icon: 'mail',
      // isSvg: true,
      // imgComponent: ConciergeIcon,
      id: 'conciergeNavBar',
    },
  ];

  const [sideNavItems, setSideNavItems] = useState(defaultSideNavItems);

  const checkIsNavLinkAllowed = (linkType = '') => {
    if (linkType !== '')
      if (linkType === 'seekerNavBar') {
        // Allow Seeker only for LB paid user
        const isLbPaidUser = Utils.isLBPaidUser();
        if (
          Utils.isFreemiumPlanActive() ||
          !isLbPaidUser ||
          (isLbPaidUser && isFreeTrial && !isEnterpriseFreeTrial)
        )
          return false;
      } else if (linkType === 'conciergeNavBar') {
        return Utils.isConciergeEnabled();
      } else if (linkType === 'enrichmentNavBar') {
        return Utils.isCrmEnrichmentEnabled();
      }
    return true;
  };

  const redirectToPath = (e, eleId) => {
    if (e) e.preventDefault();

    const redirectPath = e.currentTarget.getAttribute('data-path');

    if (props.location.pathname !== redirectPath) {
      Utils.enableBodyScroll();
      Utils.hideSecondryHeader();
      if (
        redirectPath !== null &&
        redirectPath.includes('/advanced-search/contact')
      )
        Utils.setLocalStorage('companySearch', false);
      props.history.push(redirectPath);
    }
  };

  useEffect(() => {
    if (Utils.checkIsDashboardAllowed()) {
      const dashBoardMap = defaultSideNavItems;
      dashBoardMap.unshift({
        path: '/dashboard',
        mainPath: '/dashboard',
        navName: 'dashboard',
        title: 'Dashboard',
        icon: 'home',
        id: 'homeNavBar',
      });
      setSideNavItems(dashBoardMap);
    }
  }, []);
  return (
    <div className="nav-wrapper-left">
      <Link
        onClick={e => redirectToPath(e, '')}
        className="logo-wrapper"
        data-path="/"
        to="/"
      >
        <img src={logo} className="app-logo" alt="logo" />
      </Link>
      <ul>
        {sideNavItems.map((item, index) => {
          const { navName, mainPath, id, path, title, isSvg } = item;
          return (
            checkIsNavLinkAllowed(id) && (
              <li
                key={`link${navName}`}
                className={`side-bar-item${
                  currentPath.includes(mainPath) ? ' selected-path' : ''
                }`}
                id={id}
              >
                <Link
                  onClick={e => redirectToPath(e, id)}
                  data-path={path}
                  to={path}
                >
                  {item.imgComponent && (
                    <>
                      {isSvg ? (
                        <item.imgComponent className="svg-icon" />
                      ) : (
                        <img
                          src={item.imgComponent}
                          alt={title}
                          className="svg-icon"
                        />
                      )}
                    </>
                  )}

                  {title}
                </Link>
              </li>
            )
          );
        })}
      </ul>
    </div>
  );
});

export default NavigationWrapper;
export { NavigationWrapper };
